module.exports = __webpack_public_path__ + "img/Outgrowers.553177b8.png";